/**
 * @voltxampere/ui — Wire flow (marching ants + commit flash) (S58b)
 *
 * Companion to {@link drawWireVibration} (Sprint 58a). Renders the
 * dashed-line marching-ants overlay on top of an existing wire
 * stroke during two lifecycles:
 *
 *   - **drawing**   — long-lived; dash offset advances per frame.
 *   - **committed** — 600 ms one-shot flash; alpha fades over age.
 *
 * Both modes share the same dash pattern; mode only changes the
 * stroke color + alpha curve.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export function drawWireFlow(ctx, opts, theme) {
    const { path, mode } = opts;
    if (path.length < 2)
        return;
    const head = path[0];
    if (head === undefined)
        return;
    // Mode-specific styling.
    let alpha;
    let color;
    if (mode === "committed") {
        const ttl = opts.flashTtlMs ?? 600;
        if (opts.ageMs >= ttl)
            return; // expired
        // Fade alpha 1 → 0 across the flash lifetime.
        alpha = Math.max(0, 1 - opts.ageMs / ttl);
        color = theme.accent.brassHot;
    }
    else {
        alpha = 0.85;
        color = theme.accent.brass;
    }
    ctx.save();
    if (typeof ctx.setLineDash === "function") {
        ctx.setLineDash([8, 4]);
    }
    ctx.lineDashOffset = -opts.dashOffset;
    ctx.strokeStyle = color;
    ctx.lineWidth = mode === "committed" ? 2.2 : 1.6;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.globalAlpha = alpha;
    ctx.beginPath();
    ctx.moveTo(head.x, head.y);
    for (let i = 1; i < path.length; i++) {
        const p = path[i];
        if (p === undefined)
            continue;
        ctx.lineTo(p.x, p.y);
    }
    ctx.stroke();
    ctx.restore();
}
//# sourceMappingURL=wire-flow.js.map